// material-ui
import Box from '@mui/material/Box';

// assets
import logoUrl from 'assets/logo/logo.svg'
import logoNameUrl from 'assets/logo/logoName.svg'
import LogoName from './LogoName';
import LogoIcon from './LogoIcon';
// ==============================|| LOGO SVG ||============================== //

const BASE_WIDTH = 118;
const BASE_HEIGHT = 60;
const BASE_NAME_WIDTH = 180;
// const BASE_NAME_HEIGHT = 40;
const BASE_LOGO_HEIGTH = 43;

export default function LogoMain({ scale = 1 }) {
  return (
    <>
    <Box 
      sx={{
        width: BASE_WIDTH * scale, 
        maxHeight: BASE_HEIGHT * scale, 

        display: 'flex', 
        alignItems: 'center',
        gap: '0.5rem'
      }}
    >
      <LogoIcon
        height={BASE_LOGO_HEIGTH * scale}
      />
      <LogoName
        width={BASE_NAME_WIDTH * scale}
      />
    </Box>
    </>
  );
}
